<template>
  <div class="password">
    <div class="headertop flex">
      <span style="flex:8;font-size:1.6rem;color:#2bae85;  font-weight: 700;">云上初阳统一登录认证平台</span>
      <span style="float: right;flex:2">
        <router-link to="/"
                     class="link">云上初阳PCB网站</router-link>
      </span>
    </div>
    <div class="center flex">
      <div class="Modify">
        <p>修改密码<img src="../../assets/imges/笔 (2)(1).png"
               alt=""></p>
        <hr>
        <ul>
          <li style="padding-top:1.5rem">
            <span>客户编号: 689133A</span>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>输入原密码:</span>
            <el-input show-password v-model="ChangeThePassword.oldpwd"
                      placeholder="请输入内容"></el-input>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>输入新密码:</span>
            <el-input show-password v-model="ChangeThePassword.newpwd"
                      placeholder="请输入内容"></el-input>
          </li>
          <li>
            <img src="../../assets/imges/五角星(1).png"
                 alt=""><span>确认新密码:</span>
            <el-input show-password v-model="Password"
                      placeholder="请输入内容"></el-input>
          </li>
          <li>
            <el-button @click="ModifyThe" type="warning"><i style="margin-right:1rem">完</i><i>成</i></el-button>
          </li>
        </ul>
      </div>

    </div>
    <div class="bottom ">
      <p>云上初阳</p>
      <div class="flex">
        <ul style="flex:1">
          <li>业务经理:彭易权</li>
          <li>联系电话:0755-23080620</li>
          <li>手机号码:18129846935</li>
          <li>联系 Q Q:574039568</li>
        </ul>
        <ul style="flex:1">
          <li>业务专员:陈泰先</li>
          <li>联系电话: <span>0755-23080620</span> </li>
          <li>手机号码:13129338939</li>
          <li>联系 Q Q: <span>1025203743</span> </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            Password:'',
            // 修改密码
            ChangeThePassword:{
                oldpwd:'',//原密码
                newpwd:'',//新密码
                User_Guid:window.sessionStorage.getItem('User_Guid')
            }
        }
    },
    methods:{
        // 修改密码事件
        ModifyThe(){
            
          if(  this.Password==this.ChangeThePassword.newpwd){
              if(this.Password!=''){
                   if(this.ChangeThePassword.oldpwd!=''){
                    this.$axios.post('MyFileService.asmx/UpdatePwd',this.ChangeThePassword)
                      .then((res)=>{
                          console.log(res)
                         if(this.$x2js.xml2js(res.data.d).NewDataSet.ds.type=='True' ){
                             this.$message.success('密码修改成功')
                            this.$router.push({path:"/"})
                             window.sessionStorage.clear()
                         }else{
                                this.$alert('原密码输入不正确！！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
              this.information=false
            }
          })
                         }
                      }).catch((res)=>{
                          console.log(res)
                      })
              }else{
                  this.$message.error('新密码不能为空');
              }
              }else{
                  this.$message.error('密码不能为空');
              }
          }else{
                  this.$alert('两次输入密码输入不一致！！', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
              this.information=false
            }
          })
          }
        }
    }
}
</script>
<style lang="scss" scoped>
.password {
  // 底部样式
  .bottom {
     margin: auto;
    width: 100%;
    background-color: #fafafa;
    text-align: center;
    padding-bottom: 1rem;
    position: fixed;
    bottom: 0;
    p {
      font-size: 1.5rem;
      color: #2bae85;
      font-weight: 600;
      margin-top: 1rem;

    }
    .flex {
      width: 350px;
      margin: auto;
      justify-content: center;
      align-items: center;
      margin-top: 1rem;
      ul {
        width: 50%;
        li:hover{
            color: #2bae85;
        }
        li {
          text-align: left;
          font-size: 0.8rem;
        }
      }
    }
  }
  // 头部样式
  .headertop {
    width: 60%;
    margin: auto;
    height: 100px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
   span{
        .link{
        color: #6f6f6f;
    }
    .link:hover{
        color: #2bae85;
    }
   }
  }
  // 中间样式
  .center {
    height: 35rem;
    background-color: #2bae85;
    width: 100%;
    justify-content: center;
    align-items: center;
    ul {
      margin: auto;
      text-align: center;
      li {
        height: 4rem;
        .el-button {
          width: 150px;

          i {
            font-style: unset;
            font-size: 1rem;
            text-align: center;
          }
        }
        .el-input {
          width: 200px;
        }
        img {
          width: 1rem;
        }
      }
    }
    .Modify {
      border: 0.1rem solid #dddddd;
      height: 25rem;
      width: 40%;
      background-color: #f8f8f8;
      border-radius: 0.3rem;
      hr {
        padding-top: 0.2rem;
        background-color: #dedede;
      }
      p {
        font-size: 1.5rem;
        color: #6f6f6f;
        padding-left: 0.8rem;
        padding-bottom: 0.5rem;
        img {
          width: 1rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ChildComponents/password.vue